module.exports = __webpack_public_path__ + "gl.svg?efc52e09e889e1c8589567db5d4d9934";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gl.svg
// module id = 817
// module chunks = 27